// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Category } from './category';
import { Company } from './company';
import { FileItem } from './file-item';
import { Practice } from './practice';
import { Test } from './test';
import { User } from './user';

/**
 * 
 * @export
 * @interface CourseUnion
 */
export interface CourseUnion {
    /**
     * 
     * @type {string}
     * @memberof CourseUnion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CourseUnion
     */
    version: CourseUnionVersionEnum;
    /**
     * 
     * @type {string}
     * @memberof CourseUnion
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CourseUnion
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CourseUnion
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CourseUnion
     */
    freeNavigation: boolean;
    /**
     * 
     * @type {number}
     * @memberof CourseUnion
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof CourseUnion
     */
    hours?: number;
    /**
     * 
     * @type {string}
     * @memberof CourseUnion
     */
    locale: string;
    /**
     * 
     * @type {Date}
     * @memberof CourseUnion
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof CourseUnion
     */
    updatedAt: Date;
    /**
     * 
     * @type {User}
     * @memberof CourseUnion
     */
    owner: User;
    /**
     * 
     * @type {Company}
     * @memberof CourseUnion
     */
    company: Company;
    /**
     * 
     * @type {Category}
     * @memberof CourseUnion
     */
    category?: Category;
    /**
     * 
     * @type {Test}
     * @memberof CourseUnion
     */
    test?: Test;
    /**
     * 
     * @type {Practice}
     * @memberof CourseUnion
     */
    practice?: Practice;
    /**
     * 
     * @type {Array<FileItem>}
     * @memberof CourseUnion
     */
    files?: Array<FileItem>;
    /**
     * 
     * @type {number}
     * @memberof CourseUnion
     */
    lecturesCount: number;
    /**
     * 
     * @type {number}
     * @memberof CourseUnion
     */
    laborProtectionLearnProgramId?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum CourseUnionVersionEnum {
    V1 = 'v1',
    V2 = 'v2'
}



